import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import Auth from '@/views/Auth'
import AddressInfo from '@/views/AddressInfo'
import AddressEdit from '@/views/AddressEdit'
import ProductInfo from '@/views/ProductInfo'
import ProductInfoReplace from '@/views/ProductInfoReplace'
import Replacement from '@/views/Replacement'
import Survey from '@/views/Survey'
import AnswerList from '@/views/AnswerList'
import AnswerDetail from '@/views/AnswerDetail'
// import Leaving from '@/views/Leaving'
import InteriorSales from '@/views/InteriorSales'
import LockSelect from '@/views/LockSelect'
Vue.use(Router)

export default new Router({
  // base: 'fast',  // 部署到tomcat
  base: '/fast/',   // 部署到nginx
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/auth'
      // redirect: '/indexpage'
      // redirect: '/replacement'
      // redirect: '/survey'
    },
    {
      path: '/auth',
      name: 'Auth',
      component: Auth,
    },
    {
      path: '/indexpage',
      name: 'Index',
      component: Index,
    },
    {
      path: '/address',
      name: 'AddressInfo',
      component: AddressInfo
    },
    {
      path: '/edit',
      name: 'AddressEdit',
      component: AddressEdit
    },
    {
      path: '/chooseproduct',
      name: 'ProductInfo',
      component: ProductInfo
    },
    {
      path: '/chooseproductreplace',
      name: 'ProductInfoReplace',
      component: ProductInfoReplace
    },
    {
      path: '/replacement',
      name: 'Replacement',
      component: Replacement
    },
    {
      path: '/survey',
      name: 'Survey',
      component: Survey
    },
    {
      path: '/answerlist',
      name: 'AnswerList',
      component: AnswerList
    },
    {
      path: '/answerdetail',
      name: 'AnswerDetail',
      component: AnswerDetail
    },
    {
      path: '/InteriorSales',
      name: 'InteriorSales',
      component: InteriorSales
    },
    {
      path: '/lockSelect',
      name: 'LockSelect',
      component: LockSelect
    },
    // {
    //   path: '/leaving',
    //   name: 'Leaving',
    //   component: Leaving
    // }
  ]
})
